import React from "react";
import "../../styles/ProviderTab.css";

const ProviderTab = ({ payment }) => {

    const provider = payment?.providerSnapshot;

    if (!provider) return null;

    return (

        <div className="provider-card">

            <h3>Provider Information</h3>

            <div className="provider-grid">

                <div>
                    <label>Business</label>
                    <p>{provider.businessName}</p>
                </div>

                <div>
                    <label>Provider ID</label>
                    <p>{provider.providerId || "-"}</p>
                </div>

                <div>
                    <label>Phone</label>
                    <p>{provider.phone}</p>
                </div>

                <div>
                    <label>Email</label>
                    <p>{provider.email}</p>
                </div>

                <div className="full-width">
                    <label>Business Address</label>
                    <p>{provider.address}</p>
                </div>

            </div>

        </div>

    );

};

export default ProviderTab;